import type {
  AuthenticateWithRedirectParams,
  SignUpCreateParams,
  SignUpResource,
} from '@clerk/types'
import { defineStore } from 'pinia'
import { z } from 'zod'

export const signUpSchema = z.object({
  emailAddress: z.string().email(),
  firstName: z.string().min(1),
  lastName: z.string().min(1),
})

export const useSignUpStore = defineStore('signUp', {
  state: (): { signUp: SignUpResource | null } => ({
    signUp: null,
  }),
  actions: {
    async create({ emailAddress, firstName, lastName }: SignUpCreateParams) {
      this.signUp = await this.$clerk.client.signUp.create({
        emailAddress,
        firstName,
        lastName,
      })
    },
    async authenticateWithRedirect({
      strategy,
      redirectUrl,
      redirectUrlComplete,
    }: AuthenticateWithRedirectParams) {
      await this.$clerk.client.signUp.authenticateWithRedirect({
        strategy,
        redirectUrl,
        redirectUrlComplete,
      })
    },
    async attemptEmailAddressVerification({ code }: { code: string }) {
      await this.$clerk.client.signUp.attemptEmailAddressVerification({
        code,
      })
    },
  },
})
